<template>
  <div id="app">
    <!-- 头部表单区域 -->
    <el-form :inline="true" :model="declareForm" class="demo-form-inline">
      <el-form-item>
        <el-select
          size="small"
          style="width: 130px"
          @change="subjectChange"
          v-model="declareForm.subjectId"
          placeholder="选择学科"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in subjectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间:">
        <span
          :class="{ time_listC: timeActive == item.id }"
          class="time_list"
          @click="timeClick(item.id)"
          v-for="item in timeList"
          :key="item.id"
          >{{ item.name }}</span
        >
      </el-form-item>
      <el-form-item>
        <el-date-picker
          size="small"
          v-model="declareForm.time"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          v-model="declareForm.teacherName"
          placeholder="请输入教师姓名"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="selectDeclareLists"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 表格区域 -->
    <el-table
      border
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      :data="declareList"
      stripe
      style="width: 100%"
    >
      <el-table-column
        type="index"
        label="序号"
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column
        min-width="250"
        align="center"
        prop="courseName"
        label="课程名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        width="80"
        prop="subjectName"
        label="所教学科"
      >
      </el-table-column>
      <el-table-column align="center" width="80" prop="gradeName" label="年级">
      </el-table-column>
      <el-table-column
        align="center"
        width="80"
        prop="creatorName"
        label="教师"
      >
      </el-table-column>
      <el-table-column
        align="center"
        min-width="200"
        prop="schoolName"
        label="学校"
      >
      </el-table-column>
      <el-table-column
        align="center"
        min-width="200"
        prop="updateTime"
        label="录课开始时间"
      >
      </el-table-column>
      <el-table-column
        align="center"
        min-width="200"
        prop="endTime"
        label="录课结束时间"
      >
      </el-table-column>
      <el-table-column
        align="center"
        min-width="80"
        prop="campusName"
        label="所在校区"
      >
      </el-table-column>
      <el-table-column
        align="center"
        min-width="200"
        prop="courseAddress"
        label="录课教室"
      >
      </el-table-column>
      <el-table-column
        align="center"
        min-width="200"
        prop="createTime"
        label="添加时间"
      >
      </el-table-column>
      <el-table-column align="center" width="80" label="课程介绍">
        <template slot-scope="scope">
          <div
            class="text_color"
            :class="{ text_colorA: scope.row.courseKeynote }"
          >
            {{ scope.row.courseKeynote ? "已填写" : "未填写" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" width="80" label="课后反思">
        <template slot-scope="scope">
          <div
            class="text_color"
            :class="{ text_colorA: scope.row.courseReflect }"
          >
            {{ scope.row.courseReflect ? "已填写" : "未填写" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="回放视频">
        <template slot-scope="scope">
          <div
            class="text_color"
            :class="{ text_colorA: scope.row.videoVoList.length == 1 }"
          >
            {{ scope.row.videoVoList.length == 0 ? "未上传" : "已上传" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" width="300" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="details(scope.row)" type="text">查看</el-button>
          <el-button
            :disabled="scope.row.isCreateCourse == 0 ? false : true"
            @click="createCourse(scope.row.id)"
            type="text"
            >创建课程</el-button
          >
          <el-button @click="addVideo(scope.row)" type="text"
            >上传视频</el-button
          >
          <el-button @click="videodio(scope.row)" type="text"
            >视频详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination
      background
      style="margin-top: 15px"
      layout="total, prev, pager, next, jumper"
      @current-change="currentChange"
      :total="totalCount"
    ></el-pagination>
    <!-- 视频列表 -->
    <el-dialog title="视频列表" :visible.sync="dialogVideo" width="800px">
      <div>
        <div class="viode_list" v-for="item in videoList" :key="item.id">
          <el-row style="line-height: 40px">
            <el-col :span="10">{{ item.fileName }}</el-col>
            <el-col :span="7"
              >{{ item.beginTime }}-{{
                item.endTime.slice(item.endTime.lastIndexOf(" ") + 1)
              }}</el-col
            >
            <el-col :span="7">
              <el-button @click="editVideo(item)" size="mini" type="danger"
                >编辑</el-button
              >
              <el-button
                @click="delDeclarePlaybackVideos(item.id)"
                size="mini"
                type="danger"
                >删除</el-button
              >
              <el-button size="mini" type="primary"
                ><a
                  style="color: #fff"
                  :href="item.serverHttp + item.fileUrl"
                  download
                  >下载</a
                ></el-button
              >
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
    <!-- 上传视频 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVideoUp"
      :before-close="clear"
      width="800px"
    >
      <el-form ref="videoForm" :model="videoForm">
        <el-form-item label="时间段：" :label-width="formLabelWidth" required>
          <el-date-picker
            size="small"
            v-model="videoForm.time"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="名称：" :label-width="formLabelWidth">
          <el-input
            size="small"
            style="width: 300px"
            v-model="videoForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="回放视频：" :label-width="formLabelWidth">
          <el-upload
            class="upload-demo"
            :headers="headers"
            :action="url"
            accept=".mp4"
            :file-list="fileList"
            :on-success="videoSuccess"
            :on-progress="videoProgress"
            :before-remove="beforeRemove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <!-- <div>
          <div
            class="viode_list"
            v-for="item in videoForm.videoList"
            :key="item.id"
          >
            <el-row style="line-height: 40px">
              <el-col :span="20">{{ item.fileName }}</el-col>
              <el-col style="text-align: right" :span="4">
                <el-button @click="delVideo(item.md5)" size="mini" type="danger"
                  >删除</el-button
                >
              </el-col>
            </el-row>
          </div>
        </div> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="clear">取 消</el-button>
        <el-button
          v-if="title == '上传视频'"
          size="small"
          type="primary"
          @click="videoPush"
          >确 定</el-button
        >
        <el-button v-else size="small" type="primary" @click="updatebackVideos"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看详情 -->
    <el-dialog title="申请详情" :visible.sync="dialogDetails" width="800px">
      <div class="details_list">
        <div class="details_lists"><span>教师名字</span> &nbsp;&nbsp;<div>{{ declareData.creatorName }}</div></div>
        <div class="details_lists">
         <span> 录课开始时间</span>&nbsp;&nbsp;<div>{{ declareData.beginTime }}</div>
        </div>
        <div class="details_lists"><span>录课结束时间</span>&nbsp;&nbsp;<div>{{ declareData.endTime }}</div></div>
        <div class="details_lists"><span>所教学科</span>&nbsp;&nbsp;<div>{{ declareData.subjectName }}</div></div>
        <div class="details_lists"><span>所在校区</span>&nbsp;&nbsp;<div>{{ declareData.campusName }}</div></div>
        <div class="details_lists">
          <span>录课地点</span>&nbsp;&nbsp;<div>{{ declareData.courseAddress }}</div>
        </div>
        <div class="details_lists"><span>课程名称</span>&nbsp;&nbsp;<div>{{ declareData.courseName }}</div></div>
        <div class="details_lists">
          <span>课程介绍</span>&nbsp;&nbsp;<div>{{ declareData.courseKeynote }}</div>
        </div>
        <div class="details_lists"><span>课后反思</span>&nbsp;&nbsp;<div>{{ declareData.courseReflect }}</div></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectDeclareList,
  getSubjectList,
  delDeclarePlaybackVideo,
  uplUrl,
  uploadDeclareVideo,
  updatebackVideo,
} from "@/api/home";
export default {
  data() {
    return {
      groupId: localStorage.getItem("groupId"),
      declareList: [],
      totalCount: 0,
      pageNum: 1,
      pageSize: 10,
      declareForm: {
        subjectId: "",
        time: [],
        teacherName: "",
      },
      fileList:[],
      subjectList: [],
      timeList: [
        { id: "", name: "全部" },
        { id: 1, name: "今天" },
        //   {id:2,name:'昨天'},
        { id: 3, name: "近7天" },
        { id: 4, name: "近14天" },
        { id: 5, name: "近30天" },
      ],
      timeActive: "",
      dialogVideo: false,
      declareId: "",
      videoList: [],
      dialogVideoUp: false,
      formLabelWidth: "120px",
      videoForm: {
        time: [],
        name: "",
        videoList: [],
      },
      declareData: {},
      headers: {
        token: localStorage.getItem("token"),
      },
      url: uplUrl + "/file/oss-upload",
      loading: "",
      dialogDetails: false,
      title: "上传视频",
    };
  },
  created() {
    this.selectDeclareLists();
    this.getSubjectLists();
  },
  methods: {
    beforeRemove(file, fileList) {
      for(var i=0;i<this.videoForm.videoList.length;i++){
        if(file.name==this.videoForm.videoList[i].fileName){
          this.delVideo(this.videoForm.videoList[i].md5)
        }
      }
      },
    //   页码变化
    currentChange(e) {
      this.pageNum = e;
      this.selectDeclareLists();
    },
    // 获取申课列表
    selectDeclareLists() {
      let params = {
        groupId: this.groupId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        subjectId: this.declareForm.subjectId,
        timeRange: this.timeActive,
        creatorName: this.declareForm.teacherName,
      };
      if (this.declareForm.time.length !== 0) {
        params.beginTime = this.declareForm.time[0];
        params.endTime = this.declareForm.time[1];
      }
      selectDeclareList(params).then((res) => {
        this.declareList = res.data.data.dataList;
        this.totalCount = res.data.data.totalCount;
        this.heights();
      });
    },
    // 获取学科列表
    getSubjectLists() {
      getSubjectList({
        stage: -1,
      }).then((res) => {
        this.subjectList = res.data.data;
      });
    },
    // 学科列表变化
    subjectChange() {
      this.selectDeclareLists();
    },
    // 时间点击事件
    timeClick(id) {
      this.timeActive = id;
      this.selectDeclareLists();
    },
    // 查看视频列表
    videodio(row) {
      if (row.videoVoList.length !== 0) {
        this.videoList = row.videoVoList;
        this.declareData = row;
        this.dialogVideo = true;
        return false;
      }
      this.$message.error("暂无视频，请先上传视频");
    },
    // 删除视频接口
    delDeclarePlaybackVideos(id) {
      let params = {
        declareId: this.declareData.id,
        playBackId: id,
      };
      delDeclarePlaybackVideo(params).then((res) => {
        if (res.data.code == 0) {
          let idx = this.videoList.findIndex((item) => item.id == id);
          this.videoList.splice(idx, 1);
          this.selectDeclareLists();
          this.$message({
            message: "删除成功",
            type: "success",
          });
          if (this.videoList.length == 0) {
            this.dialogVideo = false;
          }
        }
      });
    },
    // 添加视频
    addVideo(row) {
      this.declareData = row;
      this.dialogVideoUp = true;
    },
    // 视频上传成功
    videoSuccess(file) {
      this.loading.close();
      this.$message({
        message: "视频上传成功",
        type: "success",
      });
      this.videoForm.videoList = [];
      this.videoForm.videoList.push({
        fileName: file.data[0].originalFilename,
        fileUrl: file.data[0].fileName,
        md5: file.data[0].md5,
      });
    },
    // 视频上传中
    videoProgress(event) {
      if (event.loaded == event.total) {
        this.loading = this.$loading({
          lock: true,
          text: "视频上传至服务器中，请稍后。。。",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
      }
    },
    // 上传视频  删除视频
    delVideo(md5) {
      let idx = this.videoForm.videoList.findIndex((item) => item.md5 == md5);
      this.videoForm.videoList.splice(idx, 1);
    },
    // 视频提交
    videoPush() {
      let videoVoList = [];
      if (this.videoForm.time.length == 0) {
        this.$message.error("请选择时间范围");
        return false;
      }
      this.videoForm.videoList.forEach((item) => {
        let datas = {
          beginTime: this.videoForm.time[0],
          endTime: this.videoForm.time[1],
          fileName: item.fileName,
          fileUrl: item.fileUrl,
          md5: item.md5,
          id: item.id,
          declareId: this.declareData.id,
          videoTitle: this.videoForm.name,
        };
        videoVoList = [datas];
      });
      let params = {
        id: this.declareData.id,
        videoVoList: videoVoList,
      };
      uploadDeclareVideo(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.selectDeclareLists();
          this.clear();
          return false;
        }
        this.$message.error(res.data.msg);
      });
    },
    // 编辑视频提交
    updatebackVideos() {
      if (this.videoForm.time.length == 0) {
        this.$message.error("请选择时间范围");
        return false;
      }
      let datas = {};
      this.videoForm.videoList.forEach((item) => {
        datas = {
          beginTime: this.videoForm.time[0],
          endTime: this.videoForm.time[1],
          fileName: item.fileName,
          fileUrl: item.fileUrl,
          md5: item.md5,
          id: item.id,
          declareId: this.declareData.id,
          videoTitle: this.videoForm.name,
        };
      });
      updatebackVideo(datas).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.selectDeclareLists();
          this.clear();
          return false;
        }
        this.$message.error(res.data.msg);
      });
    },
    // 数据清除
    clear() {
      this.videoForm.time = [];
      this.videoForm.name = "";
      this.videoForm.videoList = [];
      this.dialogVideoUp = false;
      this.title = "上传视频";
    },
    // 视频编辑
    editVideo(item) {
      this.title = "编辑视频";
      this.videoForm.time.push(item.beginTime);
      this.videoForm.time.push(item.endTime);
      let list = {
        fileName: item.fileName,
        fileUrl: item.fileUrl,
        md5: item.md5,
        id: item.id,
      };
      this.videoForm.name = item.videoTitle;
      this.videoForm.videoList[0] = list;
      this.dialogVideo = false;
      this.dialogVideoUp = true;
    },
    // 创建课程
    createCourse(id) {
      this.$router.push({
        path: "/addCourse",
        query: {
          declareId: id,
        },
      });
    },
    // 查看百度详情
    details(row) {
      this.declareData = row;
      this.dialogDetails = true;
    },
    // 高度增加
    heights() {
      this.$nextTick(() => {
        setTimeout(() => {
          let height = document.getElementsByClassName(
            "el-table__fixed-right"
          )[0];
          height.style.height = height.offsetHeight + 8 + "px";
        });
      });
    },
  },
};
</script>
<style scoped>
.time_list {
  display: inline-block;
  padding: 0px 10px;
  cursor: pointer;
}
.time_listC {
  color: #447ed9;
}
.viode_list {
  padding: 0px 10px;
  background-color: #ecf5ff;
  margin-bottom: 10px;
  border-radius: 5px;
}
.details_lists {
  line-height: 30px;
  border-bottom: 1px solid #f1eeee;
  border-right: 1px solid #f1eeee;
  border-left: 1px solid #f1eeee;
  display: flex;
  /* margin-bottom: 5px; */
}
.details_lists:nth-child(1) {
  border-top: 1px solid #f1eeee;
}
.details_lists span{
  display: inline-block;
  padding-left: 10px;
  width: 100px;
  /* text-align: center; */
  border-right: 1px solid #f1eeee;
}
.details_lists div {
  display: inline-block;
  width: 600px;
}
.text_color {
  color: #fa8a49;
}
.text_colorA {
  color: #04c21e;
}
</style>


// WEBPACK FOOTER //
// src/components/declare/list.vue